module.exports = __webpack_public_path__ + "static/media/infra-structure.ac05ba66.svg";